import React from 'react'
import styles from './SplitLayoutTest.module.css'
import Area from '../Area'
import AbstractArea from '../AbstractArea'

import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex'

import 'react-reflex/styles.css'

class SplitLayoutTest extends AbstractArea {
  static getDescription() {
    return {
      name: 'SplitLayoutTest',
      component: SplitLayoutTest,
      label: 'Split Layout Test',
      variables: [
        {
          name: 'direction',
          type: 'select',
          label: 'Direction',
          options: [
            {
              label: 'Rijen',
              value: 'column',
            },
            {
              label: 'Kolommen',
              value: 'row',
            },
          ],
        },
        {
          name: 'areaSizes',
          type: 'array',
          // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
          label:
            "Kolom Breedte of Rij hoogte, gescheiden door comma's. Waarden kunnen gegeven worden in getallen. Een getal is verhoudingsgetal ten opzichte van de andere Rijen/Kolommen. (Een voorbeeld: 1,3,1)",
        },
        {
          name: 'minSizes',
          type: 'array',
          // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
          label:
            "initiele grootte, gescheiden door comma's. Waarden kunnen gegeven worden in pixels. (Een voorbeeld: 130px,200px,300px)",
        },
        {
          name: 'cardSizes',
          type: 'array',
          // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
          label:
            'padding Waarden kunnen gegeven worden in pixels, percentage of getallen. Een getal is verhoudingsgetal ten opzichte van de andere Rijen/Kolommen. (Een voorbeeld: 130px,1,10%)',
        },
        {
          name: 'areas',
          type: 'json',
          // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
          label: 'area definitions',
        },
      ],
    }
  }

  render() {
    try {
      if (this.props.withinSelectedTab === false && this.firstTime == null) {
        return null
      } else {
        this.firstTime = false
      }

      // return this.renderNormalPanels();
      //return this.renderResizeablePanels();
      return this.testRender2()
    } catch (error) {
      console.log(error)
    }
    return <div className={styles.main + ' ' + styles['preview']}> </div>
  }

  testRender() {
    let areaSizes = this.props.areaSizes
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ')
    }

    let mode = this.props.mode || 'preview'

    let direction = 'vertical'
    if (this.props.direction !== 'row') {
      direction = 'horizontal'
    }
    let index = 0
    let areaConfig = this.props.areas[index] || {}

    return (
      <div
        className={
          styles.main + ' ' + styles[this.props.direction] + ' ' + styles[mode]
        }
      >
        <ReflexContainer orientation={direction}>
          <ReflexElement className="left-pane">
            <div className={styles.areaContainer}>
              <Area
                {...this.props}
                index={index}
                config={areaConfig}
                onChange={this.props.onChange}
              />
            </div>
          </ReflexElement>

          <ReflexSplitter />

          <ReflexElement className="right-pane">
            <div className={styles.areaContainer}>
              <Area
                {...this.props}
                index={index}
                config={areaConfig}
                onChange={this.props.onChange}
              />
            </div>
          </ReflexElement>
        </ReflexContainer>
      </div>
    )
  }

  testRender2() {
    let areaSizes = this.props.areaSizes
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ')
    }
    let mode = this.props.mode || 'preview'
    let direction = 'vertical'
    if (this.props.direction !== 'row') {
      direction = 'horizontal'
    }
    let total = 0
    try {
      total = this.props.areaSizes.length || 0
    } catch (error) {}

    //console.log(total,this.props.areas);

    let o0 = {}
    try {
      o0 = this.props.areas[0]
    } catch (e) {}
    let o1 = {}
    try {
      o1 = this.props.areas[1]
    } catch (e) {}
    let o2 = {}
    try {
      o2 = this.props.areas[2]
    } catch (e) {}
    let o3 = {}
    try {
      o3 = this.props.areas[3]
    } catch (e) {}

    return (
      <div
        className={
          styles.main + ' ' + styles[this.props.direction] + ' ' + styles[mode]
        }
      >
        <ReflexContainer orientation={direction}>
          {0 < total && this.createArea(0, 'left-pane', o0)}
          {1 < total && <ReflexSplitter />}
          {1 < total && this.createArea(1, 'middle-pane', o1)}
          {2 < total && <ReflexSplitter />}
          {2 < total && this.createArea(2, 'right-pane', o2)}
          {3 < total && <ReflexSplitter />}
          {3 < total && this.createArea(3, 'right-pane', o3)}
          {4 < total && <ReflexSplitter />}
          {4 < total && this.createArea(4, 'right-pane', this.props.areas[4])}
          {5 < total && <ReflexSplitter />}
          {5 < total && this.createArea(5, 'right-pane', this.props.areas[5])}
        </ReflexContainer>
      </div>
    )
  }

  createArea(index, panel, areaConfig) {
    if (areaConfig == null) {
      areaConfig = {}
    }

    let areaSizes = this.props.areaSizes
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ')
    }
    let areaSize = areaSizes[index]

    areaSize = areaSize.trim()

    let flex = '0 0 auto'

    if (index === areaSizes.length - 1) {
      flex = '1 1 auto'
    }

    if (/^\d+$/.test(areaSize)) {
      if (areaSize === '0') {
        areaSize = '0 1 auto'
      }

      flex = areaSize
    }
    //if ((flex==NaN)||(flex=="NaN")){flex=""}
    // if (flex="1"){flex="0 1 auto";}

    let minSizes = this.props.minSizes
    if (typeof minSizes === 'string') {
      minSizes = minSizes.split(' ')
    }
    let minSize = null
    if (minSizes != null) minSize = minSizes[index] || null
    if (isNaN(flex) || flex === 'NaN') {
      flex = '0 1 auto' // tja
    }
    //console.log(index+" flex:",flex,minSize);
    if (minSize == null) {
      minSize = false
    }
    return (
      <ReflexElement
        className={panel}
        {...(minSize && { size: minSize })}
        flex={flex}
      >
        <div className={styles.areaContainer}>
          <Area
            {...this.props}
            index={index}
            config={areaConfig}
            onChange={this.props.onChange}
          />
        </div>
      </ReflexElement>
    )
  }

  renderResizeablePanels() {
    let areaSizes = this.props.areaSizes
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ')
    }

    let mode = this.props.mode || 'preview'

    return (
      <div
        className={
          styles.main + ' ' + styles[this.props.direction] + ' ' + styles[mode]
        }
      >
        <ReflexContainer orientation="vertical">
          {areaSizes.map((areaSize, index) => {
            let paneLocation = 'left-pane'
            if (index > 0) {
              paneLocation = 'middle-pane'
            }
            if (index > 0) {
              paneLocation = 'right-pane'
            }

            let areaConfig = this.props.areas[index] || {}
            areaSize = areaSize.trim()

            let flex = '0 0 auto'
            let fixedSize = 'auto'

            if (index === areaSizes.length - 1) {
              flex = '1 1 auto'
            }

            if (/^\d+$/.test(areaSize)) {
              if (areaSize === '0') {
                areaSize = '0 0 auto'
              }

              flex = areaSize
            } else {
              fixedSize = areaSize
            }
            let heightOrWidth =
              this.props.direction === 'row' ? 'width' : 'height'

            return (
              <div key={index}>
                <ReflexElement
                  minSize="200"
                  maxSize="800"
                  className={paneLocation}
                >
                  <div className="pane-content">
                    <div
                      className={styles.areaContainer}
                      style={{ flex, [heightOrWidth]: fixedSize }}
                    >
                      <Area
                        {...this.props}
                        index={index}
                        config={areaConfig}
                        onChange={this.props.onChange}
                      />
                    </div>
                  </div>
                </ReflexElement>
                <ReflexSplitter />
              </div>
            )
          })}
        </ReflexContainer>
      </div>
    )
  }

  renderNormalPanels() {
    let areaSizes = this.props.areaSizes
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ')
    }

    let mode = this.props.mode || 'preview'

    return (
      <div
        className={
          styles.main + ' ' + styles[this.props.direction] + ' ' + styles[mode]
        }
      >
        {areaSizes.map((areaSize, index) => {
          let areaConfig = this.props.areas[index] || {}
          areaSize = areaSize.trim()

          let flex = '0 0 auto'
          let fixedSize = 'auto'

          if (index === areaSizes.length - 1) {
            flex = '1 1 auto'
          }

          if (/^\d+$/.test(areaSize)) {
            if (areaSize === '0') {
              areaSize = '0 0 auto'
            }

            flex = areaSize
          } else {
            fixedSize = areaSize
          }
          let heightOrWidth =
            this.props.direction === 'row' ? 'width' : 'height'

          return (
            <div
              key={index}
              className={styles.areaContainer}
              style={{ flex, [heightOrWidth]: fixedSize }}
            >
              <Area
                {...this.props}
                index={index}
                config={areaConfig}
                onChange={this.props.onChange}
              />
            </div>
          )
        })}
      </div>
    )
  }
}

export default SplitLayoutTest
